<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Efb9L5/tc-custom/9781504041799.jpg?1734199018912" alt="This image is the cover for the book Eustace Diamonds, The Palliser Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eustace Diamonds, The Palliser Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>For an ambitious, keenly intelligent woman, lying proves to be the easiest way to get through life, in this Victorian-era classic.</b><br/>  <br/> Lizzie Greystock is a woman of rare cunning and determination—both of which she uses to better her lot in life. This is especially true when she manages to convince the ailing Sir Florian Eustace to marry her shortly before his demise, leaving Lizzie both a wealthy widow and the mother to Florian’s young son.<br/>  <br/> A born deceiver, Lizzie is easily able to keep up the front of a proper mourning widow. But while her inherited wealth provides her with comfort, her true love is saved for the opulent diamond necklace her late husband gifted to her. Though it is a family heirloom, she adamantly refuses to give it up, and it soon becomes the focus of her life and the lives of those around her.<br/>  <br/> The story of one woman’s ability to mask her true self and manipulate those who would do the same, <i>The</i><i>Eustace Diamonds</i> shows the true mastery of witty storytelling and social mores that made Anthony Trollope a revered author.<br/>  <br/> The Eustace Diamonds <i>is the 3rd book in the Palliser Novels, but you may enjoy reading the series in any order.</i><br/>  <br/><i>This ebook has been professionally proofread to ensure accuracy and readability on all devices.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anthony Trollope
      </h2>
      
      <p class="authorDescription body article">Anthony Trollope (1815&ndash;1882) was the author of over fifty books of fiction and nonfiction and is widely regarded as one of the preeminent English novelists of the Victorian era. Uncommon in his ability to capture both a wide readership and the highest respect of his most influential critics and peers&mdash;including luminaries such as Nathaniel Hawthorne, William Thackeray, Henry James, and George Eliot&mdash;Trollope is best remembered for two great sextets, the Chronicles of Barsetshire and the Pallisers, as well as his late-career satirical masterpiece <I>The Way We Live Now</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5ecb11a8